export const PROPOSAL_STATUS = Object.freeze({
  ASSESSMENT_HOLD: "Assessment Hold",
  UNDER_ASSESSMENT: "Under Assessment",
  READY_FOR_REVIEW: "Ready for Review",
  REVISIONS_NEEDED_CM: "Reviewed: Revisions Needed by CM",
  REVISIONS_NEEDED_CCS: "Reviewed: Revisions Needed by CCS",
  REVISIONS_NEEDED_LA: "Reviewed: Revisions Needed by LA",
  READY_TO_SEND: "Signed: Ready to Send",
});

export const ACTIONS = Object.freeze({
  TASK_LAWYER_REVIEW: "Task Lawyer for Review",
  TASK_CCS: "Task CCS for Revision",
  TASK_CM: "Task CM for Revision",
  TASK_LA: "Task LA for Revision",
  TASK_LAWYER_RE_REVIEW: "Task Lawyer for Re-Review",
  TASK_LAWYER_RE_ASSESSMENT: "Task Lawyer for Re-Assessment",
  LAWYER_SIGN_OFF: "Lawyer Sign Off",
  TASK_SEND_PROPOSAL: "Task to Send Proposal",
  SEND_PROPOSAL_BI: "Send Proposal to BI",
  SEND_PROPOSAL_DC: "Send Proposal to DC",
  HOLD: "Hold",
});

export const STATUS_ALLOWED_ACTIONS = Object.freeze({
  [PROPOSAL_STATUS.ASSESSMENT_HOLD]: [
    ACTIONS.TASK_LAWYER_REVIEW,
    ACTIONS.TASK_CCS,
    ACTIONS.TASK_CM,
    ACTIONS.TASK_LA,
    ACTIONS.TASK_LAWYER_RE_REVIEW,
    ACTIONS.LAWYER_SIGN_OFF,
  ],
  [PROPOSAL_STATUS.UNDER_ASSESSMENT]: [ACTIONS.TASK_LAWYER_REVIEW, ACTIONS.HOLD],
  [PROPOSAL_STATUS.READY_FOR_REVIEW]: [
    ACTIONS.TASK_CCS,
    ACTIONS.TASK_CM,
    ACTIONS.TASK_LA,
    ACTIONS.LAWYER_SIGN_OFF,
    ACTIONS.HOLD,
  ],
  [PROPOSAL_STATUS.REVISIONS_NEEDED_CM]: [
    ACTIONS.TASK_CCS,
    ACTIONS.TASK_LA,
    ACTIONS.TASK_LAWYER_RE_REVIEW,
    ACTIONS.HOLD,
  ],
  [PROPOSAL_STATUS.REVISIONS_NEEDED_CCS]: [
    ACTIONS.TASK_CM,
    ACTIONS.TASK_LA,
    ACTIONS.TASK_LAWYER_RE_REVIEW,
    ACTIONS.HOLD,
  ],
  [PROPOSAL_STATUS.REVISIONS_NEEDED_LA]: [
    ACTIONS.TASK_CM,
    ACTIONS.TASK_CCS,
    ACTIONS.TASK_LAWYER_RE_REVIEW,
    ACTIONS.HOLD,
  ],
  [PROPOSAL_STATUS.READY_TO_SEND]: [ACTIONS.SEND_PROPOSAL_BI, ACTIONS.SEND_PROPOSAL_DC, ACTIONS.TASK_SEND_PROPOSAL],
});
